

export function timeInMsToString(timeInMs: number|undefined|null) {
    if (timeInMs == null || timeInMs == 0) {
        return "-";
    }
    const finish = new Date(timeInMs); // - timezoneOffset);
    return `${finish.getHours().toString().padStart(2, "0")}:${finish.getMinutes().toString().padStart(2, "0")}:${finish.getSeconds().toString().padStart(2, "0")}`;
}

export function timeInMsToDateTimeString(timeInMs: number|undefined|null) {
    if (timeInMs == null || timeInMs == 0) {
        return "-";
    }
    const finish = new Date(timeInMs); // - timezoneOffset);
    return `${finish.getDate()}/${finish.getMonth() + 1}@${finish.getHours().toString().padStart(2, "0")}:${finish.getMinutes().toString().padStart(2, "0")}`;
}

export function timeInMsToStringUTC(timeInMs: number|undefined|null) {
    if (timeInMs == null || timeInMs == 0) {
        return "-";
    }
    const finish = new Date(timeInMs); // - timezoneOffset);
    return `${finish.getUTCHours().toString().padStart(2, "0")}:${finish.getUTCMinutes().toString().padStart(2, "0")}:${finish.getUTCSeconds().toString().padStart(2, "0")}`;
}

export function dateTimeInMsToString(timeInMs: number|undefined|null) {
    if (timeInMs == null || timeInMs == 0) {
        return "-";
    }
    const finish = new Date(timeInMs); // - timezoneOffset);
    return `${finish.getFullYear().toString().padStart(2, "0")}-${(finish.getMonth()+1).toString().padStart(2, "0")}-${finish.getDate().toString().padStart(2, "0")} ${finish.getHours().toString().padStart(2, "0")}:${finish.getMinutes().toString().padStart(2, "0")}:${finish.getSeconds().toString().padStart(2, "0")}`; //.${finish.getMilliseconds().toString().padStart(2, "0")}`;
}

export function dateTimeInMsToStringWithMs(timeInMs: number|undefined|null) {
    if (timeInMs == null || timeInMs == 0) {
        return "-";
    }
    const finish = new Date(timeInMs);
    return `${finish.getFullYear().toString().padStart(2, "0")}-${(finish.getMonth()+1).toString().padStart(2, "0")}-${finish.getDate().toString().padStart(2, "0")} ${finish.getHours().toString().padStart(2, "0")}:${finish.getMinutes().toString().padStart(2, "0")}:${finish.getSeconds().toString().padStart(2, "0")}.${finish.getMilliseconds().toString().padStart(3, "0")}`;
}

export function dateTimeInMsToTimeString(timeInMs: number|undefined|null) {
    if (timeInMs == null || timeInMs == 0) {
        return "-";
    }
    const finish = new Date(timeInMs); // - timezoneOffset);
    return `${finish.getHours().toString().padStart(2, "0")}:${finish.getMinutes().toString().padStart(2, "0")}:${finish.getSeconds().toString().padStart(2, "0")}`; //.${finish.getMilliseconds().toString().padStart(2, "0")}`;
}

export function dateTimeInMsToTimeStringWithMs(timeInMs: number|undefined|null) {
    if (timeInMs == null || timeInMs == 0) {
        return "-";
    }
    const finish = new Date(timeInMs);
    return `${finish.getHours().toString().padStart(2, "0")}:${finish.getMinutes().toString().padStart(2, "0")}:${finish.getSeconds().toString().padStart(2, "0")}.${finish.getMilliseconds().toString().padStart(3, "0")}`;
}

export function timeStringToMs(time: string) {
    if (time === "-" || time === '') {
        return null;
    }

    const re = /^0?(\d{0,2}):0?(\d{0,2}):0?(\d{0,2})/;
    const matches = time.match(re);
    if (matches != null) {
        const MS_PER_SEC = 1000;
        const MS_PER_MIN = 60 * MS_PER_SEC;
        const MS_PER_HOUR = 60 * MS_PER_MIN;
        for (let i = 0; i != matches.length; i++) {
        }
        return parseInt(matches[1]) * MS_PER_HOUR + parseInt(matches[2]) * MS_PER_MIN + parseInt(matches[3]) * MS_PER_SEC;
    }

    return null;
}

export function validTimeStr(time: string) {
    return time === "-" || time === '' || time.match(/^\d{2}:[0-5]\d:[0-5]\d$/)
}

export function validDateTimeStr(dateTime: string) {
    return dateTime === "-" || dateTime.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(\.\d{1,3})?$/)
}

export function timeInMsDiffToString(timeInMs: number|undefined, timeStartInMs: number|undefined) {
    if (timeInMs == null || timeStartInMs == null || timeInMs == 0 || timeStartInMs == 0) {
        return "-";
    }

    const diff = new Date(timeInMs - timeStartInMs);
    return `${(diff.getHours()-1).toString().padStart(2, "0")}:${diff.getMinutes().toString().padStart(2, "0")}:${diff.getSeconds().toString().padStart(2, "0")}`;
}

function getTimezoneOffset() {
    throw new Error("Function not implemented.");
}

export function addDateToTime(time: string): Date | null {
    if (!time.match(/^\d{2}:\d{2}:\d{2}$/)) {
        console.error("Ogiltigt tidsformat. Förväntat format: HH:mm:ss");
        return null;
    }

    const [hours, minutes, seconds] = time.split(":").map(Number);

    const now = new Date(); // Hämtar dagens datum
    now.setHours(hours, minutes, seconds, 0); // Sätter timmar, minuter och sekunder

    return now;
}

export function dateTimeStringToMs(dateTime: string): number | null {
        const matches = dateTime.match(
            /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,3}))?$/
        );
        if (!matches) {
            console.error(
                "Invalid date format. Expected format: yyyy-MM-dd HH:mm:ss(.SSS)"
            );
            return null;
        }

        const year = parseInt(matches[1], 10);
        const month = parseInt(matches[2], 10);
        const day = parseInt(matches[3], 10);
        const hours = parseInt(matches[4], 10);
        const minutes = parseInt(matches[5], 10);
        const seconds = parseInt(matches[6], 10);
        const milliseconds = parseMilliseconds(matches[7]);

        const date = new Date(
            year,
            month - 1,
            day,
            hours,
            minutes,
            seconds,
            milliseconds
        );

        if (
            Number.isNaN(date.getTime()) ||
            date.getFullYear() !== year ||
            date.getMonth() !== month - 1 ||
            date.getDate() !== day ||
            date.getHours() !== hours ||
            date.getMinutes() !== minutes ||
            date.getSeconds() !== seconds
        ) {
            return null;
        }

        return date.getTime();
  }

function parseMilliseconds(millisecondsText: string | undefined) {
        if (!millisecondsText) {
            return 0;
        }

        if (millisecondsText.length === 1) {
            return parseInt(millisecondsText, 10) * 100;
        }

        if (millisecondsText.length === 2) {
            return parseInt(millisecondsText, 10) * 10;
        }

        return parseInt(millisecondsText, 10);
}

  